<template>
  <div class="row m-t-sm">
    <div class="col-xs-12 col-sm-5">
      {{ item.description }}

      <template v-if="isLoad(item)">
        <br>
        <p class="muted small">
          Date: {{ load.date }} | Rego: {{ load.rego }}
        </p>
      </template>
      <div v-if="isLoad(item)">
        <b>Dockets:</b> <br>
        <div v-for="docket of load.dockets" :key="docket.id">
          {{ docket.number }}
        </div>
      </div>
    </div>

    <div class="col-xs-4 col-sm-2" v-if="isPerTonneCharge(item) || isLoad(item)">
      {{ item.quantity }}t
    </div>
    <div class="col-xs-4 col-sm-2" v-if="isLoad(item)">
      {{ costPerTonne(item) }}
    </div>
    <div class="col-xs-4 col-sm-2" v-if="isPerTonneCharge(item)">
      {{ getLoadChargePerTonne(load, item) }}
    </div>
    <div class="col-xs-8 col-sm-2 col-sm-offset-2" v-if="isSingleCharge(item)">
      {{ getLoadCharge(load, item) | money }}
    </div>

    <div class="col-xs-4 col-sm-3 amount text-right">
      <template v-if="isLoad(item)">
        {{ cost(item) }}
      </template>
      <template v-if="isPerTonneCharge(item) || isSingleCharge(item)">
        {{ getLoadChargeTotal(load, item) }}
      </template>
    </div>
  </div>
</template>

<script>
  import accounting from 'accounting'
  import { find } from 'lodash'

  export default {
    props: ['load', 'user', 'item'],

    methods: {
      costPerTonne (item) {
        return `${accounting.formatMoney(item.per_unit_cost)}/t`
      },

      cost (item) {
        return accounting.formatMoney(item.per_unit_cost * item.quantity)
      },

      isLoad (item) {
        return item.type === 'load'
      },

      isPerTonneCharge (item) {
        return item.type === 'job' || item.type === 'charge_per_tonne'
      },

      isSingleCharge (item) {
        return item.type === 'charge_single'
      },

      getLoadCharge (load, item) {
        let loadCharge = find(load.charges, function (charge) {
          return charge.description === item.description
        })

        // http://support.codium.com.au/a/tickets/8650
        // always show client rate on invoice
        return loadCharge && loadCharge.client_rate
          ? loadCharge.client_rate || 0
          : 0
      },

      getLoadChargePerTonne (load, item) {
        return `${accounting.formatMoney(this.getLoadCharge(load, item))}/t`
      },

      getLoadChargeTotal (load, item) {
        const rate = item.quantity * this.getLoadCharge(load, item)

        return `${accounting.formatMoney(rate)}`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InvoiceInvoicedItem.vue?9105f3a2